import React, { useState, useRef, useEffect, useCallback } from "react";

import {
    Box,
    Divider,
    TextField,
    Grid,
    Typography,
    Button,
    IconButton,
    InputAdornment,
    Container,
    Card,
    styled,
    FormHelperText,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Link,
    ListItemButton,
    List,
    Chip,
    ListItem,
    ListItemText,
    ListSubheader,
    TableContainer,
    TableCell,
    Table,
    TableHead,
    TableRow,
    TableBody,
    FormControlLabel,
    FormGroup,
    Checkbox,
    ButtonGroup,
    Tooltip,
    Fab
} from '@mui/material';

import * as yup from "yup";
import dayjs from "dayjs";

import { useFormik } from 'formik';

import { grey } from "@mui/material/colors";
import { CommonIcons, icons } from "../../../common/CommonIcons"

import { capitalizeString } from "../../../../utils/formatString"
import { getUId } from "../../../../utils/formatId"

import { useAppContextFeatures } from "../../../../context/AppContext";
import { useSystemPrompt } from "../../../../hooks/useSystemPrompt";

import { useRepositories, repositoryTypes, targetTypes as repositoryTargetTypes } from "../../../../hooks/api/useRepositories"

import { useSystemRoutes, routeTypes } from "../../../../hooks/useSystemRoutes";

import {
    packingMethods,
} from "../../../../schema/repositories/packagePackSchema"

export const validationSchema = yup.object({
    uomId: yup
        .string()
        .required("Required"),
    qty: yup.lazy((val) => {

        let maxQty = val?.maxQty ? val.maxQty : 0

        let valueSchema;

        valueSchema = yup
            .number("")
            .typeError("Invalid")
            // .min(parseFloat(minQty))
            .max(parseFloat(maxQty), `Max : ${maxQty}`)
            .positive("More than 0")
            .required("Required")

        return yup.object().shape({
            value: valueSchema,
            maxQty: yup.mixed().nullable().typeError("Invalid")
        })

    })
})

export const initialValues = {
    uomId: "",
    uomName: "",
    qty: {
        value: "0",
        maxQty: 20
    },
}

const StyledCard = styled(Card)(({ theme }) => ({
    padding: theme.spacing(1)
}));

export default function SectionPackages({
    // data,
    routeType,
    locationId,
    dataUoms,
    documentNos,
    documentIds
    // handleRemovePackages
}) {

    const [dataSavedPackages, setDataSavedPackages] = useState([])
    const [isLumpsumMode, setIsLumpsumMode] = useState(false)

    const { setSystemLoading } = useAppContextFeatures();
    const { promptMessage } = useSystemPrompt()

    const { getRoute } = useSystemRoutes(routeType)

    const {
        list: listPackages,
        create: createPackage,
        remove: removePackage,
        filterOperatorTypes
    } = useRepositories({ repositoryType: repositoryTypes.package, targetType: repositoryTargetTypes.package })

    const fetchPackagesByDocuments = async () => {

        setSystemLoading(true)

        try {

            const props = {
                limit: -1,
                skip: 0,
                sortInfo: {
                    id: "repo_number",
                    dir: -1,
                },
                filterValue: [
                    {
                        name: "doc_number",
                        operator: filterOperatorTypes.havingInOr,
                        value: JSON.stringify(documentNos)
                    }
                ]
            }

            const { data } = await listPackages(props)

            setDataSavedPackages(data?.repositories ? data.repositories : [])


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        setSystemLoading(false)

        return false;

    }

    // remove packages in dialog
    const handleRemovePackages = async ({ ids }) => {

        setSystemLoading(true)

        try {

            const { data } = await removePackage({ ids })

            console.log('data', data)


        } catch (error) {
            promptMessage(false, `${error?.message}`)
        }

        // refresh the packages
        fetchPackagesByDocuments()

        setSystemLoading(false)

    }

    // check the related packages are in lumpsum mode
    const checkSavedPackagesIsLumpsumMode = () => {

        console.log('dataSavedPackages', dataSavedPackages)

        const selected = dataSavedPackages.filter(i => i.packing_type === packingMethods.lumpsum.id)

        setIsLumpsumMode(selected.length > 0)

    }

    useEffect(() => {

        fetchPackagesByDocuments()

    }, [])

    useEffect(() => {

        checkSavedPackagesIsLumpsumMode()

    }, [dataSavedPackages])

    const onSubmit = async (currentValues) => {

        setSystemLoading(true)

        try {

            // check the saved packags must have at least one
            if (dataSavedPackages.length <= 0) {
                throw new Error(`There is no existing package in the selection for append`)
            }

            let operationDate = dayjs().format("YYYY-MM-DD")

            // create package 
            let repository = {
                number_alternative: getUId({ version: 1 }),
                repo_date: operationDate,
                remark: "Append"
            }

            let props = {
                location_id: locationId,
                uom_id: currentValues.uomId,
                uom_lbl: currentValues.uomName,
                packing_type: packingMethods.lumpsum.id,
            }

            props.document_id = documentIds

            let items = []

            // get the any one of the related packages for duplicate the items
            dataSavedPackages[0].items.forEach(i => {
                items.push({
                    id: i.item_id,
                    code: i.code,
                    name: i.item_name,
                    description: i?.description,
                    qty: i.qty,
                    uom_lbl: i?.uom_name,
                    uom: i?.uom_id,
                    price: i?.uom_price,
                    props: {
                        document_item_id: i?.document_item_id
                    }
                })
            })

            let data = {
                repository,
                props,
                items
            }

            console.log('data', data)

            const { data: responsePackage } = await createPackage({ data })

            console.log('responsePackage', responsePackage)

            promptMessage(true, `Packages packing submitted`)

            // refresh the data
            fetchPackagesByDocuments()


        } catch (error) {
            promptMessage(false, `Action Failed (${error?.message})`)
        }

        setSystemLoading(false)


    }

    const formik = useFormik({
        initialValues,
        validationSchema,
        onSubmit,
        enableReinitialize: true
    });

    const { handleSubmit, handleChange, values, errors, touched, setFieldValue } = formik;

    const RenderNew = () => {

        // check only able to lumpsum mode
        if (isLumpsumMode === false) return <></>

        return (
            <Box>
                <form onSubmit={handleSubmit}>
                    <Divider>
                        <Typography
                            sx={{
                                fontWeight: '500',
                                pb: 1
                            }}
                        >
                            Append Package
                        </Typography>
                    </Divider>
                    <StyledCard sx={{ p: 2 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={12} sm={12} md={3} textAlign={"right"}>
                                <TextField
                                    margin="dense"
                                    size="small"
                                    // autoFocus
                                    fullWidth
                                    name={`qty.value`}
                                    label="Qty"
                                    type="text"
                                    variant="outlined"
                                    value={values?.qty?.value ? values.qty.value : ''}
                                    onChange={handleChange}
                                    onFocus={event => {
                                        event.target.select();
                                    }}
                                    error={Boolean(errors?.qty?.value)}
                                    helperText={errors?.qty?.value}
                                    autoComplete="off"
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment position="end">
                                                {` / ${parseFloat(values?.qty?.maxQty)}`}
                                            </InputAdornment>
                                        ),
                                    }}
                                />

                            </Grid>

                            <Grid item xs={12} sm={12} md={6.5}>

                                <FormControl
                                    margin="dense"
                                    fullWidth
                                    size="small"
                                    error={Boolean(errors?.uomId)}
                                >
                                    <InputLabel id="packageUomId">Package Uom</InputLabel>
                                    <Select
                                        // disabled={
                                        //     (values.rows.reduce((total, i) => total + parseFloat(i.qty.value), 0) <= 0)
                                        // }
                                        labelId="packageUomId"
                                        label="packageUomId"
                                        name={`uomId`}
                                        onChange={(e) => {
                                            let val = e.target.value

                                            const selected = dataUoms.filter(i => i.id === val)

                                            if (selected.length) {
                                                setFieldValue(`uomId`, val)
                                                setFieldValue(`uomName`, selected[0]?.name)
                                            }

                                        }}
                                        sx={{
                                            textAlign: 'left',
                                        }}
                                        MenuProps={{
                                            MenuListProps: {
                                                sx: {
                                                    py: 0
                                                },
                                            }
                                        }}
                                        // value={itemValues?.uomId ? itemValues.uomId : ""}
                                        value={values?.uomId ? values.uomId : ""}
                                    >
                                        {
                                            dataUoms.map((i, index) => {
                                                return (
                                                    <MenuItem
                                                        key={index}
                                                        value={i.id}
                                                        sx={{
                                                            textTransform: 'capitalize',
                                                            px: 1.5,
                                                            fontSize: 14
                                                        }}
                                                        disableGutters
                                                        divider
                                                    >
                                                        {i.name}
                                                    </MenuItem>
                                                )
                                            })
                                        }
                                    </Select>
                                    <FormHelperText>
                                        {
                                            errors?.uomId
                                        }
                                    </FormHelperText>
                                </FormControl>

                            </Grid>

                            <Grid item xs={12} sm={12} md={2.5} sx={{ mt: 1 }}>
                                <Button
                                    variant="contained"
                                    type="submit"
                                    // size="small"
                                    fullWidth
                                >
                                    <CommonIcons name={icons.plus} />
                                    Add
                                </Button>
                            </Grid>

                        </Grid>
                    </StyledCard>
                </form>
            </Box>
        )
    }

    const RenderItems = () => {

        return (
            <List
                disablePadding
            >
                {
                    dataSavedPackages && dataSavedPackages.map((i, index) => {
                        return (
                            <ListItem
                                key={index}
                                disablePadding
                                disableGutters
                                sx={{
                                    mt: 0,
                                    pb: 0,
                                    mb: 0,
                                }}
                            >
                                <Box
                                    sx={{
                                        width: '100%'
                                    }}
                                >
                                    <Divider>
                                        <Typography
                                            sx={{
                                                fontWeight: '500',
                                                my: 1,
                                                fontSize: 13,
                                                color: grey[500]
                                            }}
                                        >
                                            Package #{`${index + 1} / ${i.number_alternative}`}
                                        </Typography>
                                    </Divider>

                                    <RenderItem
                                        row={i}
                                        index={index}
                                    />
                                </Box>
                            </ListItem>
                        )
                    })
                }
            </List>
        )
    }

    const RenderItem = ({ row, index }) => {

        let items = row?.items ? row.items : []

        // console.log('iem', items)

        // get the total qty
        let totalQty = items.reduce((total, item) => total + parseFloat(item.qty), 0)

        return (
            <StyledCard sx={{ p: 0, width: '100%' }}>
                <TableContainer
                // component={Paper}
                >
                    <Table
                        // sx={{ minWidth: 650 }} 
                        aria-label="simple table"
                        size="small"
                    >
                        <TableHead>
                            <TableRow>
                                {/* <TableCell align="left" sx={{}}>#{index + 1}</TableCell> */}
                                <TableCell align="left" sx={{ fontSize: 13 }} colSpan={3}>
                                    <Box
                                        display={"flex"}
                                        flexDirection={"row"}
                                        justifyContent={"flex-start"}
                                        alignItems={"center"}
                                    >
                                        <Box>
                                            <Chip
                                                variant="outlined"
                                                size="small"
                                                // color={}
                                                sx={{
                                                    // color: grey[100]
                                                }}
                                                label={
                                                    `${capitalizeString({ val: row.packing_type })}`
                                                }
                                            />
                                        </Box>
                                        <Box
                                            sx={{
                                                ml: 1
                                            }}
                                        >
                                            <Chip
                                                variant="outlined"
                                                size="small"
                                                // color={}
                                                sx={{
                                                    // color: grey[100]
                                                }}
                                                label={row.repo_date}
                                            />
                                        </Box>
                                    </Box>

                                </TableCell>
                                <TableCell align="right" sx={{}} width={160}>

                                    <Box
                                        display={"flex"}
                                        flexDirection={"row"}
                                        justifyContent={"space-between"}
                                        alignItems={"center"}
                                    >
                                        <Chip
                                            variant="outlined"
                                            size="small"
                                            // color={}
                                            sx={{
                                                // color: grey[100]
                                            }}
                                            label={`1 ${row.uom_lbl} (Qty: ${totalQty})`}
                                        />
                                        <IconButton
                                            sx={{
                                                // backgroundColor: 'red'
                                            }}
                                            color="error"
                                            size="small"
                                            onClick={() => {
                                                handleRemovePackages({ ids: [row.id] })
                                            }}
                                        >
                                            <CommonIcons name={icons.remove} />
                                        </IconButton>
                                    </Box>

                                </TableCell>
                            </TableRow>
                        </TableHead>
                        {/* <TableHead>
                            <TableRow>
                                <TableCell sx={{ backgroundColor: grey[200], }} align="center">No.</TableCell>
                                <TableCell sx={{ backgroundColor: grey[200], }} align="left" width={160}>Document</TableCell>
                                <TableCell sx={{ backgroundColor: grey[200], }} align="left">Items</TableCell>
                                <TableCell sx={{ backgroundColor: grey[200], }} align="right" width={160}>Qty</TableCell>
                            </TableRow>
                        </TableHead> */}
                        <TableBody>
                            {
                                items.map((item, index) => {

                                    return (
                                        <TableRow
                                            key={index}
                                            sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                        >
                                            <TableCell component="th" align="center" scope="row" sx={{ width: 20 }}>
                                                {(index + 1)}
                                            </TableCell>
                                            <TableCell align="left">
                                                <Link
                                                    sx={{
                                                        fontSize: 14,
                                                        fontWeight: '800',
                                                    }}
                                                    rel="noopener"
                                                    underline="hover"
                                                    target="_blank"
                                                    href={`${getRoute(`repositories/package/view?docNumbers=${item.doc_number}&autoPrint=1`)}`}
                                                >
                                                    {item.doc_number}
                                                </Link>
                                                <Typography sx={{ fontSize: 12 }}>{item.doc_type}</Typography>
                                                {/* <ListItemText
                                                    primary={
                                                        // <Typography sx={{ fontSize: 14, fontWeight: '600' }}>{item.doc_number}</Typography>
                                                        <Link to={`${getRoute('abc')}`}>
                                                            {item.doc_number}
                                                        </Link>
                                                    }
                                                    secondary={}
                                                /> */}
                                            </TableCell>
                                            <TableCell align="left">
                                                <ListItemText
                                                    primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{item.item_name}</Typography>}
                                                    secondary={<Typography sx={{ fontSize: 12 }}>{item.code}</Typography>}
                                                />
                                            </TableCell>
                                            <TableCell align="right">
                                                <ListItemText
                                                    primary={<Typography sx={{ fontSize: 14, fontWeight: '600' }}>{parseFloat(item.qty)}</Typography>}
                                                    secondary={<Typography sx={{ fontSize: 12 }}>{item?.uom_name}</Typography>}
                                                />
                                            </TableCell>
                                            {/* <TableCell align="right">1</TableCell> */}
                                        </TableRow>
                                    )
                                })
                            }
                        </TableBody>
                    </Table>
                </TableContainer>
            </StyledCard>
        )
    }

    return (
        // <StyledCard sx={{ m: 0, mx: 1, overflowY: 'scroll' }}>
        <Box
            sx={{
                px: 2,
                py: 2
            }}
        >
            {
                RenderNew()
            }
            {
                RenderItems()
            }
        </Box>
        // </StyledCard>
    )

}